import { ReactNode } from "react";

interface PageTitleProps {
    title: string;
    icon?: ReactNode;
}

export default function PageTitle({ title, icon }: PageTitleProps) {
    return (
        <div className="w-full mb-5">
            <div className="flex items-center gap-4">
                {icon && <span className="flex items-center">{icon}</span>}
                <h1 className="m-0 text-inherit font-inherit whitespace-nowrap">{title}</h1>
                <div className="flex-1 h-[1px] bg-light_gray dark:bg-night_surface"></div>
            </div>
        </div>
    );
}

